/**
 * Hook to fetch filter options from the API.
 * Uses TanStack Query for caching and automatic refetching.
 */

import { useQuery } from '@tanstack/react-query'
import { fetchFilterOptions, HttpError } from '../services/listSearchApi'
import type { FilterOptionsResponse } from '../types'

export function useFilterOptions() {
  return useQuery<FilterOptionsResponse, Error>({
    queryKey: ['filterOptions'],
    queryFn: ({ signal }) => fetchFilterOptions(signal),
    staleTime: 5 * 60 * 1000, // 5 minutes - filter options don't change frequently
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
    retry: (failureCount, error) => {
      // Don't retry on 4xx errors (user errors)
      if (error instanceof HttpError && error.status >= 400 && error.status < 500) return false
      // Retry other errors up to 2 times
      return failureCount < 2
    },
  })
}
